"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var errorHandler_1 = require("../../../../common/service/errorHandler");
var CashSummaryBlocks_1 = require("./Cash/CashSummaryBlocks");
var MultiCurrencyFinanceSummaryBlock_1 = require("./Finance/MultiCurrency/MultiCurrencyFinanceSummaryBlock");
var NoComparisonFinanceRatesBlock_1 = require("./Finance/NoComparison/rates/NoComparisonFinanceRatesBlock");
var FinanceBreakdownSummaryBlockContainer = function (_a) {
    var isCashDeal = _a.isCashDeal, isMultiCurrency = _a.isMultiCurrency, prices = _a.prices, financeDetails = _a.financeDetails, comparisonRate = _a.comparisonRate, _b = _a.showTitle, showTitle = _b === void 0 ? true : _b;
    var _c, _d;
    if (isMultiCurrency && !isCashDeal) {
        return (<MultiCurrencyFinanceSummaryBlock_1.default {...{ totalPayable: (_c = prices) === null || _c === void 0 ? void 0 : _c.totalPayable, showTitle: showTitle, financeDetails: financeDetails, isMultiCurrency: isMultiCurrency }}/>);
    }
    if (isCashDeal) {
        return <CashSummaryBlocks_1.default prices={prices} isMultiCurrency={isMultiCurrency}/>;
    }
    if (!comparisonRate) {
        return <NoComparisonFinanceRatesBlock_1.default financeDetails={financeDetails} totalPayable={(_d = prices) === null || _d === void 0 ? void 0 : _d.totalPayable}/>;
    }
    errorHandler_1.default.handleError('No breakdown view selected');
    return;
};
exports.default = FinanceBreakdownSummaryBlockContainer;
